import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { ApiError } from "../types";

const API_URL = import.meta.env.VITE_API_URL;

export type OfferItem = {
	itemType: number;
	token: string;
	identifierOrCriteria: string;
	startAmount: string;
	endAmount: string;
};

export type ConsiderationItem = OfferItem & {
	recipient: string;
};

export type OrderDTO = {
	offerer: string;
	zone: string;
	orderType: number;
	startTime: number;
	endTime: number;
	zoneHash: string;
	salt: string;
	offer: OfferItem[];
	consideration: ConsiderationItem[];
	totalOriginalConsiderationItems: number;
	conduitKey: string;
	counter: number;
	signature: string;
};

export type OrderInput = {
	parameters: Omit<OrderDTO, "signature">;
	signature: string;
};

export const useListNFTMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<Response, ApiError, OrderInput>({
		mutationFn: async (data) => {
			const order: OrderDTO = {
				...data.parameters,
				signature: data.signature,
			};
			const response = await fetch(`${API_URL}/marketplace/orders`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(order),
			});

			if (!response.ok) {
				const error = await response.json();
				throw error;
			}

			return response.json();
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: ["nfts"],
			});
			toast.success("NFT listed successfully");
		},
		onError: (error) => {
			toast.error(error.message.slice(0, 300));
		},
	});
};
